var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar-container"},[_c('div',{staticClass:"sidebars brush-black"},[_c('SidebarLeft'),_c('SidebarRight')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }